// Welcher Stand laeuft am Geraet - und seit wann?
//
// appVersion (package.json) steht seit Langem auf demselben Wert und sagt
// nichts. Wer im SocketAdmin wissen will, ob ein TV den neuen Stand hat,
// braucht drei Angaben:
//
//   build        - die Build-Id, die beim Bauen in DIESEN Code geschrieben
//                  wurde (process.env.BUILD_ID, dieselbe wie in build.json).
//   loaderBuild  - die Id, unter der der Loader (tizenStartapp ab 2.7.4) die
//                  Bundles zuletzt angefordert hat (localStorage tv_app_build).
//                  Weicht sie von `build` ab, kam der Code aus dem Cache oder
//                  der Server hat waehrend des Starts gewechselt. Aeltere
//                  Loader und LG schreiben den Wert nicht - dann null.
//   startedAt    - wann dieser Code gestartet ist. Bleibt der Wert nach einem
//                  Neustart-Befehl stehen, hat das Geraet nicht neu gestartet
//                  (Standby haelt die App im Speicher).
//
// Mit der Build-Id vom Server daneben sieht man: laeuft, was ausgeliefert ist?

/* global APP_VERSION */

const STARTED_AT = Date.now();
const LOADER_BUILD_KEY = 'tv_app_build';

function readLoaderBuild() {
  try {
    return window.localStorage.getItem(LOADER_BUILD_KEY) || null;
  } catch (e) {
    return null;
  }
}

const AppBuild = {
  get build() {
    return process.env.BUILD_ID || null;
  },
  get loaderBuild() {
    return readLoaderBuild();
  },
  // Woher der Loader die Build-Id beim Start hatte (tizenStartapp ab 2.7.6):
  // 'server' (build.json gelesen), 'cache' (gemerkte Id - Netz/Server beim
  // Start nicht erreichbar), 'none' (unversioniert). Aeltere Loader: null.
  get loaderSource() {
    try {
      return window.__loaderBuildSource || null;
    } catch (e) {
      return null;
    }
  },
  get startedAt() {
    return STARTED_AT;
  },
  // Die Version des Loaders (tizenStartapp), wie er sie selbst in der
  // Statuszeile zeigt: `const APP_VERSION` in dessen js/main.js. Top-Level-
  // const eines klassischen Skripts ist fuer alle Skripte desselben Dokuments
  // sichtbar - die App laeuft im Dokument des Loaders.
  //
  // Warum neben wgtVersion (appInfo.version = config.xml): bei den
  // 6.5-Builds 2.7.0 bis 2.7.3 wurde die config.xml nie hochgezaehlt, dort
  // steht 2.0.1. Erst beide Werte zusammen sagen, welcher Loader wirklich
  // laeuft. Aeltere Loader (2.0.x) haben kein APP_VERSION - dann null.
  get loaderVersion() {
    try {
      return typeof APP_VERSION !== 'undefined' ? String(APP_VERSION) : null;
    } catch (e) {
      return null;
    }
  },
};

export default AppBuild;



// WEBPACK FOOTER //
// ./src/helpers/AppBuild.js